module.exports = __webpack_public_path__ + "img/icon19.8359bb40.svg";